import { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import CustomAlert from '../../components/CustomAlert';
import config from '../../config/Constant';
import { putRequest } from '../../helpers/apiHandler';
import CloseIcon from '../../layouts/SVG/CloseIcon';

const WhatsAppPricingRatesUpdateModal = ({ show, onClose, rowData, getPricingRatesData }) => {
  const { access_token } = useSelector((state) => state.auth.user);
  const { id, country_code, country_name, pricing_category, cost_per_conversation } = rowData;

  const [newCost, setNewCost] = useState('');
  const [loading, setLoading] = useState(false);
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  useEffect(() => {
    if (show && cost_per_conversation !== undefined) {
      setNewCost(parseFloat(cost_per_conversation).toFixed(4));
    }
  }, [show, cost_per_conversation]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const costValue = parseFloat(newCost);
    if (isNaN(costValue) || costValue < 0) {
      setAlertState({
        message: 'Please enter a valid cost (0 or greater)',
        show: true,
        variant: 'danger',
      });
      return;
    }

    setLoading(true);

    const data = {
      cost_per_conversation: costValue,
    };

    putRequest(`/v2/admin/whatsapp/pricing-rates/${id}`, data, access_token.token, (res) => {
      setLoading(false);
      if (res.success) {
        setAlertState({
          message: 'Pricing rate updated successfully',
          show: true,
          variant: 'success',
        });
        setTimeout(() => {
          onClose();
          getPricingRatesData();
        }, 1000);
      } else {
        setAlertState({
          message: res.message || 'Failed to update pricing rate',
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({ message: '', show: false, variant: '' });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Body style={{ padding: '24px' }}>
        <CloseIcon handleModalClose={onClose} />
        <Modal.Title as="h4" style={{ margin: '8px 0 24px' }}>
          Update Pricing Rate
        </Modal.Title>

        <CustomAlert
          message={alertState.message}
          show={alertState.show}
          variant={alertState.variant}
          closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
        />

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Country</Form.Label>
            <Form.Control type="text" value={`${country_name} (${country_code})`} disabled />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Category</Form.Label>
            <Form.Control
              type="text"
              value={pricing_category}
              disabled
              style={{ textTransform: 'capitalize' }}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Cost per Conversation (USD)</Form.Label>
            <Form.Control
              type="number"
              step="0.0001"
              min="0"
              value={newCost}
              onChange={(e) => setNewCost(e.target.value)}
              placeholder="Enter cost per conversation"
              required
            />
            <Form.Text className="text-muted">
              Enter the cost in USD with up to 4 decimal places
            </Form.Text>
          </Form.Group>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="outline-secondary" onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Updating...
                </>
              ) : (
                'Update'
              )}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default WhatsAppPricingRatesUpdateModal;
